import { AddParkingPlaceComponent } from "./../../components/add-parking-place/add-parking-place.component";
import { ChartData, UserGroups } from "./../../../assets/config/models";
import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  ElementRef,
} from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { Router, ActivatedRoute, Params, RouterModule } from "@angular/router";
import { CoreService } from "../../services/coreService";
import * as _ from "lodash";
import {
  UntypedFormBuilder,
  FormControl,
  Validators,
  UntypedFormGroup,
  ReactiveFormsModule,
  FormsModule,
} from "@angular/forms";
import { ValidatorsService } from "../../shared/services/validators.service";
import { ParkingPlaceLiveParkingComponent } from "../../components/parking-place-live-parking/parking-place-live-parking.component";
import { AddValletParkingComponent } from "../add-vallet-parking/add-vallet-parking.component";
import { ParkingPlaceParkingHistoryComponent } from "../../components/parking-place-parking-history/parking-place-parking-history.component";
import { ValletParkingStaffsComponent } from "../vallet-parking-staffs/vallet-parking-staffs.component";
import { PosMachinesComponent } from "../../components/pos-machines/pos-machines.component";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { GoogleMap } from "@angular/google-maps";

declare var toastr: any;

@Component({
  selector: "app-view-vallet-parking",
  templateUrl: "./view-vallet-parking.component.html",
  styleUrls: ["./view-vallet-parking.component.scss"],
  providers: [CoreService, DatePipe],
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    ParkingPlaceLiveParkingComponent,
    AddValletParkingComponent,
    ParkingPlaceParkingHistoryComponent,
    ValletParkingStaffsComponent,
    PosMachinesComponent,
    NgxChartsModule,
  ],
})
export class ViewValletParkingComponent implements OnInit {
  @ViewChild(AddParkingPlaceComponent, { static: true })
  editParking?: AddParkingPlaceComponent;
  @ViewChild(GoogleMap)
  map?: GoogleMap;
  @ViewChild("total", { static: true }) subscriptionLimit: ElementRef;
  live_parkingP = 1;
  parking_historyP = 1;
  public data: any = [];
  public id: any;
  subscriptionForm: UntypedFormGroup;
  groupName: string;
  groupTypes = UserGroups;
  form: any;
  // Bar Chart
  revenueChart: ChartData[];

  sharedSettings = {
    view: [500, 250],
    showXAxis: true,
    showYAxis: true,
    gradient: false,
    showLegend: false,
    showXAxisLabel: false,
    showYAxisLabel: false,
    roundDomains: true,
    animations: true,
    colorScheme: this.coreService.colorScheme,
  };
  passColor = this.coreService.passColor;

  constructor(
    private activatedRoute: ActivatedRoute,
    private coreService: CoreService,
    private datePipe: DatePipe,
    public changeDetector: ChangeDetectorRef,
    private builder: UntypedFormBuilder,
    private validatorsService: ValidatorsService,
  ) {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.id = params["id"];
      this.getValletParking(this.id);
    });

    this.subscriptionForm = this.builder.group({
      limit: [null, [Validators.required, this.validatorsService.number()]],
    });
    this.groupName = JSON.parse(localStorage.getItem("user_details")).group;
  }

  ngOnInit() {}

  logChild() {
    console.log(this.editParking, "=======================");
  }

  getValletParking(id) {
    this.coreService.GetValletParkingById(id).then((result) => {
      this.data = result;
      this.form = result.data;
      // this.resetSubscriptionLimit();
    });
  }

  resetSubscriptionLimit() {
    if (this.data.subscription.limit) {
      this.subscriptionForm.patchValue({
        limit: this.data.subscription.limit,
      });
    }
  }

  async updateSubscriptionLimit(limit) {
    console.log("We have the number", this.subscriptionForm.valid);
    try {
      if (this.subscriptionForm.valid) {
        await this.coreService
          .updateSubscriptionLimit(
            this.data.subscription.id,
            this.subscriptionForm.value,
          )
          .toPromise();
        this.data.subscription.limit = this.subscriptionForm.value.limit;
      } else {
        this.resetSubscriptionLimit();
      }
    } catch (error) {
      this.resetSubscriptionLimit();
    }
  }

  configureBarChart() {
    let revenueData = this.data.revenue;
    revenueData = _.orderBy(revenueData, (element) => element.day as any, [
      "desc",
    ]);
    let temp = [];

    revenueData.forEach((day) => {
      let tempObject: ChartData = {
        name: this.datePipe.transform(day.day, "shortDate").toString(),
        series: [],
      };
      day.beneficiary.forEach((element) => {
        tempObject.series.push({
          name: element.name,
          value: element.amount,
        });
      });
      temp.push(tempObject);
    });
    console.log("revenueChart", temp);
    this.revenueChart = [...temp];
    this.changeDetector.detectChanges();
  }

  updateValetParking(form) {
    console.log(form);
    this.coreService
      .UpdateValetParking(form, this.id)
      .then((result) => {
        // this.iLoader = false;
        // this.router.navigate(['supplier/thankyou']);
        toastr.success("", "Valet parking updated successfully..", {
          timeOut: 2000,
        });
      })
      .catch((result) => {
        // this.iLoader = false;
        toastr.error("", "error updating this time..", { timeOut: 2000 });
      });
  }

  refreshMap() {
    google.maps.event.trigger(this.map?.googleMap, "resize");
  }
}
